export default {
    "秒杀": "Flash Sale",
    "团购商品": "Group Buying",
    "甄选商品": "Featured Products",
    "手机访问": "Mobile Access",
    "分享": "Share",
    "商品合计金额": "Subtotal",
    "运费": "Shipping Fee",
    "赠送积分": "Points Reward",
    "促销折扣": "Promotion Discount",
    "优惠券折扣": "Coupon Discount",
    "积分抵现": "Points Deduction",
    "使用积分抵扣": "Use Points to Deduct",
    required: 'Required',
    nickname: 'Nickname',
    enterNickname: 'Please enter nickname',
    gender: 'Gender',
    male: 'Male',
    female: 'Female',
    secret: 'Secret',
    birthday: 'Birthday',
    selectDate: 'Select date',
    "暂无数据": "No data",
    "加载中": "Loading",
    "电商批发商场": "Wholesale Mall",
    "热销推荐": "Hot Deals",
    "用户未发表评论": "User has not commented",
    '请输入关键字搜索': 'Please enter a search keyword',
    "请输入完整的支付密码!": "Please enter the complete payment password!",
    "获取验证码": "Get verification code",
    "请输入验证码": "Please enter the verification code",
    "验证码":"Verification code",
    "发送":"Send",
    "已发送，请注意查收": "Sent, please check your mailbox",
    cancelOrderMap: {
        0: "I don't want it.",
        1: "Misplaced the product",
        2: "Duplicate order",
        3: "Receive failed",
        4: "Other reasons",
    },
    order: {
        cancel: "Cancel order",
        payment: "Pay now",
        confirm: "Confirm receipt",
        remind: "Remind for Shipment",
        return: "Request for product refund",
        evaluate: "Review now",
        logistics: "View logistics",
        noRefund: "Unrefunded",
        refunding: "Refund in progress",
        refundSuccess: "Refund succeeded",
        refundFail: "Refund failed",
        expressCompany: 'Courier',
        trackingNo: 'Tracking No.',
        noOrderShipping: 'No shipping record',
        noTransitSteps: 'No tracking updates',
        logisticsLoadFail: 'Failed to load logistics. Please try again later.',
        remindTitle: "Remind for Shipment",
    },
    "subOrder": 'Submit',
    "1": "Misplaced products",
    "2": "Repeat Order",
    "3": "Failed to receive",
    "4": "Other reasons",
    "KEY": "英语(en)",
    "-连接已建立-": "-Connection established-",
    ",才可提币": ", and then cash can be withdrawn.",
    "[code]值错误": "[code] value is incorrect",
    "[symbol]参数为空": "[symbol] parameter is empty",
    "goodsFreightTips1": "1. Freight Shipping Rate Formula: Freight rate = Dispatch fee + Distance + Delivery fee",
    "creditQuotaINFO": "100,000 to 30,000,000 with flexible limit and no restrictions, with a maximum loan term of one year.",
    "authentic": "100% Original",
    "homeIconTips1": "100% Original",
    "goodsFreightTips2": "2. If the postage conditions are not met, the freight cost shall be charged according to the actual circumstances.",
    "goodsFreightTips3": "3. The right of final interpretation belongs to the Platform.",
    "dayReturns7": "7 days return",
    "homeIconTips2": "7 days return",
    "homeIconTips4": "Secure payment",
    "safe": "Safe and Worry-free",
    "safePayment": "Secure Payment",
    "homeDownloadtips4": "Shop App",
    "homeDownloadtips41": "Merchant App",
    "keep": "Maintain",
    "saveQr": "Save QR code",
    "payPal": "PayPal",
    "coinBlock": "Currency",
    "validatorRequire": "Required fields cannot be empty",
    "edit": "Edited by",
    "markDefaultAddress": "Mark as default Shipping address",
    "不能为空": "It cannot be empty",
    "cancelOrder2": "Don't like it, don't want it",
    "contactUs1": "If you don't want to borrow money from your friends, please contact us.",
    "不在交易时段": "Out of trading session",
    "不在可提现时间内": "Out of withdrawal period",
    "猜你喜欢": "Guess you like it",
    "paramError": "Parameter error",
    "参数错误": "Parameter error",
    "参数异常，消息获取失败": "\"Parameter error. Failed to get a message",
    "Operate": "Operation",
    "operationSuccess": "Operation succeeded",
    "操作成功": "Operation succeeded",
    "操作类型不能小于0": "The operation type cannot be less than 0",
    "操作类型不是整数": "The operation type is not an integer",
    "操作类型为空": "The operation type is empty",
    "view": "View",
    "Checkorder": "View Order",
    "logistics": "View Logistics",
    "CheckDetails": "View Details",
    "lowOpinion": "Bad reviews",
    "产品不存在": "The product does not exist",
    "产品剩余数量不足": "The remaining quantity of the product is insufficient",
    "interest": "Accrue interest",
    "dealSuccess": "Successful",
    "successTips": "Successful",
    "beSeller": "Become a Seller",
    "homeBannertips1": "Become a Seller",
    "承兑商不存在": "The acceptor does not exist",
    "orderCity": "City",
    "city": "City",
    "程序错误": "Program error",
    "持有币种不足": "Not enough funding",
    "recharge": "Deposit",
    "rechargeSuccessful": "Deposit succeeded",
    "rechargeAddress": "Deposit Address",
    "rechargeMethod": "Deposit Mode",
    "rechargeRecord": "Deposit Record",
    "充值价值不得大于最大限额": "The Deposit amount cannot exceed the maximum limit range",
    "充值价值不得小于最小限额": "The Deposit amount cannot be less than the minimum limit range",
    "充值金额不能小于1": "The Deposit amount cannot be less than 1 (including two decimal digits)",
    "充值链错误": "Deposit link error",
    "rechargeNum": "Deposit Amount",
    "充值数量不能小于等于0": "The Deposit amount cannot be less than or equal to 0",
    "rechargeTips": "\"Deposit Note: \"\"Please fill in the transfer amount correctly. Otherwise, the system may fail to pass the approval and affect the recharging progress\"\".\"",
    "dealing": "In-process",
    "processing": "In-process",
    "ship": "Boat",
    "creditText1": "Start-up Loans are to avoid the trouble of borrowing money",
    "businessloan": "Start-up Loan Application",
    "存在不同杠杆的持仓单": "There are different leverage options",
    "cancelOrder7": "There is a significant problem",
    "存在重复的角色名称": "Duplicate role name",
    "大于最大采购数量": "More than the maximum purchase amount",
    "代理层级错误": "Agent error",
    "delivered": "Pending shipment",
    "pendingPayment": "Pending payment",
    "待付款的订单无法放行": "Unable to release pending payment",
    "comment": "To be reviewed",
    "receipt": "To be received",
    "pending": "Pending payment",
    "loanHistory": "Loan Record",
    "rates": "Loan Interest Rate",
    "term": "Loan Terms",
    "application": "Loan Application",
    "creditWorry": "Worry-free loan",
    "orderUnitprice": "Unit price",
    "当前地址格式错误": "The current address is in the wrong format",
    "当前订单不为待付款状态，无法取消": "The current order is not in the pending status. It cannot be cancelled.",
    "当前还需交易": "The transaction is still required",
    "currentRate": "Current exchange rate",
    "sure": "Of course",
    "当日才可申购": "Only available for purchase on the same day",
    "当日可提现次数不足": "Insufficient number of cash withdrawals per day",
    "receivedAddress": "Recipient Address",
    "orderAddress": "Address",
    "登陆密码不符合设定": "Wrong password",
    "登陆密码长度不符合设定": "Wrong password",
    "login": "Log in",
    "loginIn": "Log in",
    "signIn": "Log in",
    "loginSuccess": "Succeeded",
    "登录过期，请重新登录": "The session expired. Please log in again",
    "LoginPassword": "Login Password",
    "登录密码必须6-12位": "The password must be 6-12 characters",
    "登录密码不能为空": "The field cannot be empty",
    "登录失败": "Failed to log in",
    "clickUpload": "Click to upload",
    "phoneNumber": "Mobile Number",
    "电话号码已绑定": "The mobile number is already linked",
    "电话号码已绑定其他用户": "The mobile number is already linked to another user",
    "email": "Email",
    "shopCollection": "Add the store to favourites",
    "订单": "Order",
    "trackOrder": "Order",
    "订单不存在": "The order does not exist",
    "orderTrack": "Order Inquiry",
    "serialNumber": "Order No.",
    "orderSummary": "Total Orders",
    "cancelOrderSuccess": "Cancelled Orders",
    "订单退款成功": "Refunded Orders",
    "订单退款失败": "Failed Orders for Refund",
    "orderDetails": "Order Details",
    "orderInfo": "Order Information",
    "订单已签收": "The order has been received",
    "订单已取消": "The order has been cancelled",
    "订单已取消，无法放行": "The order has been cancelled and cannot be released",
    "订单已取消，原因:超时自动取消订单": "The order has been cancelled automatically due to the expiration of the waiting period",
    "订单已取消，原因:手动发起取消订单": "The order has been cancelled manually",
    "订单已完成": "The order was completed",
    "订单已完成，无法放行": "The order has been completed and cannot be released",
    "moneyOrderStatus": "Order Status",
    "orderPrefix": "Total Orders",
    "subscription": "Subscribe",
    "aboutText2": "Limit: 100,000-30,000,000, flexible repayment method with low interest, no upfront fee, online loan, no phone call for verification, confidential information, and same-day lending.",
    "additional": "More",
    "evaluateOrderSuccess": "Review succeeded",
    "goodsShip": "Shipment",
    "发起退款申请": "Request for refund",
    "send": "Send",
    "发现新版本，请升级到最新版本": "Found a new version, please upgrade to the latest version",
    "visitStore": "Visit Store",
    "collAccount": "Loan Method",
    "loanMethod": "Loan Method",
    "classification": "Category",
    "服务器错误": "Server error",
    "服务器错误(500)": "Server error (500)",
    "servicePolicy": "Service policy",
    "PaymentOrder": "Payment order",
    "uploadTips": "Proof of payment (Upload screenshot of payment details)",
    "copy": "Copy",
    "copySuccess": "Copied successfully",
    "该产品未上架": "This product is not listed",
    "该产品已上市，无法购买": "This product is on the market and cannot be purchased",
    "该订单已取消": "This order has been cancelled",
    "remindRepeat": "This order has been reminded",
    "该广告剩余数量不足": "The remaining number of ads left is insufficient",
    "该基金尚未开放购买": "The fund has not been opened for purchase",
    "该基金尚已封闭": "The fund has been closed",
    "productAvailable": "This product has been removed",
    "该邮箱已被订阅": "This email has already been subscribed",
    "notOpen": "This payment method is not open to your region",
    "格式有误:充值金额不能小于1(包含俩位小数)": "The format is wrong: the Deposit amount cannot be less than 1 (including two decimal digits)",
    "userCenter": "Personal Center",
    "Item": "Item(s)",
    "跟单倍数输入错误": "Multiple input error",
    "跟单参数输入错误": "Multiple input error",
    "more": "More",
    "更新提醒": "Update reminder",
    "工作地址不能为空": "The field cannot be empty",
    "homeBannertips2": "Total Commission",
    "orderTotal": "Total",
    "buyHistory": "Purchase Records",
    "购买矿机时间不得低于托管订单剩余时间": "The time to purchase mining machines must not be less than the remaining time of the hosting order",
    "purchageHistory": "Purchase History",
    "addCartMessageFaild": "The product is already in your shopping cart",
    "fixedRate": "Fixed interest rate",
    "aboutUs": "About us",
    "about": "About us",
    "followers": "Follow",
    "当前余额": "Current Balance",
    "followedSuccess": "Succeeded",
    "myFollowedShops": "Follow the store",
    "广告不存在": "The advertisement does not exist",
    "广告已下架": "The advertisement has been removed",
    "orderSpecification": "Specification",
    "countryOf": "Nationality",
    "areaCode": "International Area Code",
    "App下载(买家端)": "App Download (Buyer)",
    "App下载(卖家端)": "App Download (Seller)",
    "orderNation": "Country",
    "nation": "Country",
    "repayment": "Repayment",
    "repay": "Repayment method",
    "reAmount": "Repayment amount",
    "cycle": "Repayment cycle",
    "loginTips": "Don't have an account number?",
    "noAccount": "Don't have an account number?",
    "NoProductSelected": "No product has been selected yet",
    "shipping": "Shipping",
    "highOpinion": "Good reviews",
    "favorableRate": "Rate of good reviews",
    "myPraiseRate": "Rate of good reviews",
    "totalNum": "Total",
    "partner": "Cooperative suppliers",
    "partnersTit": "Partner - Online Lending Platform",
    "BackHome": "Back to Home page",
    "or": "or",
    "freight": "Cargo",
    "orderFreight": "Cargo",
    "getCoupons": "Get More Coupons",
    "基金剩余购买金额不足": "The remaining purchase amount of the fund is insufficient",
    "quickLoan": "Quick loan",
    "records": "Record",
    "proceed": "Continue",
    "storeSeachTips3": "Home",
    "家庭地址不能为空": "The field cannot be empty",
    "cancelOrder4": "Fake brand",
    "price": "Price",
    "piece": "Pcs",
    "transactionPassword": "Transaction password",
    "交易员不存在": "The seller does not exist",
    "交易员不能跟随自己": "The sellers cannot follow themselves",
    "交易员跟随人数已满": "The number of traders following is full",
    "交易员未开启带单": "The seller has not opened the order",
    "交易员无法跟随另一个交易员": "The seller cannot follow another seller",
    "角色被用户关联，不可删除": "Role is associated by user. It cannot be deleted",
    "角色不存在": "Role does not exist",
    "receiver": "Receiver",
    "financial": "Solve your financial problems",
    "successLoan": "The loaning process finished successfully",
    "borrow": "The loaning process failed to finish",
    "loanAgree": "Loan Agreement",
    "amount": "Amount",
    "金额不在购买区间": "The amount is not in the purchase range",
    "validatorMaxNumber": "The amount exceeds the limit range",
    "金额错误": "Amount error",
    "validatorChineseAndEnglish": "Only Chinese and English languages are supported; the input content is 8-64 characters",
    "oldPassword": "Old password",
    "旧密码不能为空": "The field cannot be empty",
    "旧密码不正确": "Incorrect old password",
    "可平仓合约张数不足": "Insufficient number of close position contracts",
    "service": "Customer service",
    "custService": "Customer service",
    "homeDownloadtips1": "Cross-border e-commerce wholesale shop",
    "矿机不存在": "Mining machine does not exist",
    "矿机未解锁，无法购买": "The mining machine is locked and cannot be purchased.",
    "From": "From",
    "历史基金无法购买": "Past funds cannot be purchased",
    "historySearch": "History Search",
    "payment": "Pay Now",
    "buyNow": "Purchase Now",
    "homeBannerbtn": "Join Now",
    "evaluate": "Review Now",
    "连续输入错误三次，请3分钟后再试": "Invalid input occurred three times in a row. Please try again in 3 minutes",
    "contactUs": "Contact us",
    "twoPawword": "The passwords do not match",
    "creditQuota": "Flexible limit range",
    "retailPrice": "Retail Price",
    "领取成功": "Received successfully",
    "pageviews": "Number of views",
    "myPageviews": "Number of views",
    "buyRules": "Buyer's Rules",
    "买入金额需要在区间内": "The purchase amount should be in the range",
    "卖方无法取消该订单": "The seller cannot cancel the order",
    "cancelOrder3": "The seller shipped the wrong goods",
    "sellerRules": "Seller's Policy",
    "noDataFound": "No data found",
    "没有找到用户": "No user found",
    "dailyNewArrival": "Daily Deals",
    "verificationCode":"verification Code",
    "username": "Username",
    "pleaseEnterUsername":"Please enter Username",
    "pleaseEnterVerificationCode":"Please enter the verification code",
    "password": "Password",    
    "getVerificationCode":"Verification code",
	"tryAgainLater":"Try again later",
    "密码必须6-12位": "Password must be 6-12 characters",
    "密码不能为空": "The field cannot be empty",
    "密码不正确": "Wrong password",
    "wrongPassword": "The number of attempts exceeds 3 times. Please try again tomorrow",
    "validatorPassword": "Password should be comprised of 6-12 letters and digits(contains special characters)",
    "goodsFreeShipping": "Free of charge",
    "orderName": "Name",
    "defaultAddress": "Default address",
    "noCartTips": "Your shopping cart is empty. Start shopping",
    "notLogin": "You haven't logged in yet.",
    "unSelectedProduct": "You have not selected any product",
    "evaluationUploading": "Pictures are still being uploaded. Please try again later",
    "您当前可分配额度不足": "Your current allocatable limit is not enough",
    "yourEmail": "Your email address",
    "您没有符合条件的收款方式": "You have no eligible payment method",
    "您已存在订单": "You have an order",
    "您已购买过体验矿机,不得重复购买": "You have already purchased the experience mining machine. Do not buy it again",
    "photoExample": "Photo Example",
    "homeDownloadtips2": "Brands on sale",
    "Evaluate": "Reviews",
    "evaluateOrder": "Reviews with pictures",
    "evaluateInput": "Reviews with pictures",
    "homeDownloadtips5": "Download for Apple",
    "cancelOrder9": "Other reasons",
    "businessPhone": "Store Contact Number",
    "businessEmail": "Corporate Email",
    "walletHistory": "Wallet History",
    "亲属地址不能为空": "The field cannot be empty",
    "亲属电话不能为空": "The field cannot be empty",
    "亲属关系不能为空": "The field cannot be empty",
    "亲属姓名不能为空": "The field cannot be empty",
    "empty": "Empty",
    "evaluateOrderPlaceholder": "Please review the product",
    "checkAgreement": "Please accept the agreement!",
    "请检查网络连接": "Please check your network connection",
    "returnDetailTips": "Please give a review about the product",
    "switchLang": "Please switch to another language to check",
    "请切换其他语言后查看": "Please switch to another language to check",
    "请上传图片": "Please upload pictures",
    "uploadPhoto": "Please upload photos",
    "请稍后再试": "Please try again later",
    "请稍后重试": "Please try again later",
    "pleaseSetLoginPassword": "Please enter the login password",
    "pleaseSetMobileNumber": "Please enter the mobile number",
    "pleaseEnterPhoneNumer": "Please enter the mobile number",
    "plaeseEnterInvitaionCode": "Please enter the invitation code",
    "pleaseEnterEmail": "Please enter the email",
    "enterTips": "Please enter",
    "pleaseInput": "Please enter",
    "validatorFourMoreNumber": "Please enter more than 4 characters",
    "pleaseValidPostCode": "Please enter more than 4 characters",
    "validatorSixNumber": "Please enter 6 characters",
    "请输入充值币种": "Please enter the Deposit currency",
    "plaseEnterRechargeAddress": "Please enter the deposit address",
    "pleaseEnterAmount": "Please enter the deposit amount",
    "pleaseInputCorrectNumber": "Please enter a number greater than 0",
    "pleaseEnterAddress": "Please enter the address",
    "请输入关键字搜索": "Please enter the keyword to search",
    "headerSearchTips": "Please enter the keyword to search",
    "pleaseEnterOldPassword": "Please enter the old password",
    "pleaseEnterPassword": "Please enter password",
    "pleaseConfirmPassword": "Please confirm password",
    "请输入内容": "Please enter content",
    "plaseeENterConfirmPassword": "Please enter the confirmation password",
    "pleaseEnterQuantity": "Please enter amount",
    "请输入搜索关键字": "Please enter the keyword to search",
    "withdrawInputTips": "Please enter the withdrawal address",
    "plaseeEnterNewPassword": "Please enter the new password",
    "yourName": "Please enter the name",
    "pleaseEnterAccount": "Please enter the account number",
    "请输入正确的货币数量": "Please enter the correct amount",
    "请输入正确的金额": "Please enter the correct amount",
    "validatorPhone": "Please enter the correct mobile number",
    "pleaseValidPhone": "Please enter the correct mobile number",
    "请输入正确的数量": "Please enter the correct amount",
    "inpuEmailErro": "Please enter the correct email address",
    "pleaseValidEmail": "Please enter the correct email address",
    "validatorEmail": "Please enter the email in the correct format",
    "请输入正确的质押金额": "Please enter the correct pledge amount",
    "请输入正确的质押天数": "Please enter the correct number of days to pledge",
    "pleaseCorrectAddress": "Please enter the correct withdrawal address",
    "请填写正确的电话号码": "Please enter the correct mobile number",
    "请填写正确的验证码": "Please enter the correct verification code",
    "mailboxCheck": "Please enter the correct email address",
    "请填写正确的邮箱地址": "Please enter the correct email address",
    "请先绑定谷歌验证器": "Please bind Google Authenticator first",
    "请先添加收款方式": "Please add the payment method first",
    "请先通过高级认证": "Please pass the advanced certification first",
    "cancelOrderTitle": "Please select an order cancellation reason",
    "selectCountry": "Please select a nationality",
    "请选择买卖方式": "Please select the payment method",
    "selectPeriod": "Please select a period",
    "returnOrderTitle": "Please select the return reason",
    "请选择正确的币种": "Please select the correct currency",
    "请重新登录": "Please log in again",
    "blockchainNetwork": "Blockchain network",
    "渠道未开通": "Channel not opened",
    "Cancel": "Cancel",
    "取消": "Cancel",
    "cancelSuccess": "Cancelled successfully",
    "cancelOrder": "Cancel order",
    "cancel": "Cancel order",
    "CancelOrder": "Cancel order",
    "myUnfollow": "Unfollow",
    "cancelReason": "Cancellation Reason",
    "all": "View All",
    "AllProducts": "All Products",
    "btnSure": "Confirm",
    "确认": "Verify",
    "entRepay": "Confirm payment",
    "confirmPayPaw": "Confirm the transaction password",
    "confirmPassword": "Confirm password",
    "delAllHistoryRecord": "Are you sure you want to delete all history records?",
    "confirm": "Confirm receipt",
    "date": "Date",
    "客户端下载": "Client download",
    "提现方式": "Withdrawal method",
    "scanAndDown": "Scan QR code to download the APP",
    "homeDownloadtips6": "Scan QR code to download the APP",
    "delete": "Delete",
    "sellerPanelLogin": "Seller login",
    "merchantSettled": "Partnership",
    "businessInformation": "Business information",
    "sellerZone": "Merchant area",
    "商家已确认，已进入备货状态": "The seller has been confirmed and has started the stocking process",
    "长时间未付款，系统自动取消订单": "The order has been cancelled automatically due to the expiration of the waiting period",
    "commodity": "Product",
    "orderCommodity": "Product",
    "commodityCollection": "Product Collection",
    "productDescription": "Product Description",
    "myCommodityCollection": "Favorite Products",
    "goodsNumber": "Products Quantity",
    "goodsShipTips": "After placing an order, it will be shipped within 24 hours. The shipping time depends on logistics and may be prolonged. Please pay attention to the logistics information or contact Customer Service",
    "productInfo": "Product Information",
    "uploadSuccess": "Uploaded successfully",
    "uploadError": "Failed to upload, please try again",
    "uploading": "Uploading...",
    "upNew": "New products",
    "previous": "Previous step",
    "prevPage": "Previous page",
    "cancelOrder5": "Less shipment, missed shipment",
    "desc": "Set as the default address",
    "setAsTheDefaultAddress": "Set as the default address",
    "setUp": "Setup",
    "setSuccess": "Setup succeeded",
    "setUpPayPaw": "Set transaction password",
    "setPassword": "Set password",
    "申购数量错误": "The amount of purchase is wrong",
    "申请成功": "Succeeded",
    "applyLoan": "Apply for a loan",
    "applicationAmount": "Requested amount",
    "noSmaller": "The requested amount cannot be less than",
    "nomax": "The requested amount cannot exceed",
    "applicant": "Applicant",
    "applicantDate": "Application Date",
    "return": "Request for a product refund",
    "applicantIn": "Application in progress",
    "身份证已实名过!": "The ID card has been verified!",
    "审核已通过": "Approved",
    "审核中": "Under review",
    "state": "Province/State/Region",
    "dealFail": "Failed",
    "fail": "Failed",
    "orderTime": "Time",
    "time": "Time",
    "ActualLedger": "Actual received",
    "actualAccount": "Actual account",
    "实名认证未通过，无法进行高级认证": "Authentication failed; unable to perform advanced authentication",
    "confirmReceiveGoods": "Confirm receipt of the product",
    "collect": "Favorites",
    "collectionSuccess": "Added to favourites successfully",
    "wishlist": "Favorite products",
    "cancelOrder6": "Received damaged product",
    "desc5": "Wrong shipping address? Contact",
    "consigneeName": "Recipient name",
    "shippingAddress": "Recipient address",
    "收款方输入错误": "Input error",
    '购物车还没有商品': "Your shopping cart is empty",
    '去购物': "Start shopping",
    "mobile": "Mobile No.",
    "mobilePhone": "Mobile number",
    "handleFee": "Service charge",
    "handlingFee": "Service charge",
    "home": "Home",
    "授权状态未成功": "Authorization status failed",
    "pleaseSetAreaCode": "Enter the country name and area code to search",
    "searchCountry": "Enter the country name and area code to search",
    "desc3": "Enter the transaction password",
    "desc4": "Enter your transaction password",
    "赎回状态异常": "Redemption status abnormal",
    "quantity": "Quantity",
    "orderAmount": "Quantity",
    "orderQuantity": "Quantity",
    "inputNum": "Numbers",
    "orderTax": "Tax",
    "orderFee": "Taxes",
    "tax": "Taxation",
    "delivery": "Delivery & collection",
    "storeSeach": "Search for product in this store",
    "search": "Search",
    "所选汇率不存在": "The selected exchange rate does not exist",
    "allProduct": "All products",
    "提币数量不能小于等于0": "The withdrawal amount cannot be less than or equal to 0",
    "creditText2": "Provide start-up loan and capital turnover services",
    "returnOrderSuccess": "Submitted successfully",
    "Submitareview": "Submit reviews",
    "submitApplica": "Submit the application",
    "提交失败": "Submission Failed",
    "提交失败，当前有未处理订单": "Submission failed. There are currently open orders",
    "hint": "Tip",
    "提示": "Tip",
    "withdraw": "Withdraw",
    "提现不得大于限额": "Cash withdrawal cannot be greater than the limit",
    "提现不得小于限额": "Cash withdrawal cannot be less than the limit",
    "withdrawSuccess": "Orders submitted successfully",
    "withdrawAddress": "Withdrawal address",
    "withdrawRecord": "Withdrawal record",
    "withdrawNum": "Withdrawal quantity",
    "tipsRemindsSuccess": "Reminder succeeded",
    "remindSuccess": "Reminder succeeded",
    "RemindShip": "Remind to ship",
    "remind": "Remind to ship",
    "remindTitle": "Remind to ship",
    "tipsRemindsText": "After shipping the products, the seller will get a notification",
    "remindContent": "After shipping the products, the seller will get a notification only once",
    "tipsRemindsMerchant": "Remind seller",
    "days": "day(s)",
    "addCartMessage": "Added to your shopping cart successfully",
    "addAddress": "Add new address",
    "addAddressOrModifyAddress": "Add new address/Change address",
    "addCart": "Add to the shopping cart",
    "图片不得大于10M": "File size for an image cannot be larger than 10M",
    "图片不得大于2M": "File size for an image cannot be larger than 2M",
    "图片大小不能超过2M！": "File size for an image cannot exceed 2M!",
    "图片上传失败": "Failed to upload the image",
    "recommendclass":"Shop by Category",
    "recommend": "Recommend",
    "recommendedProducts": "Popular Items",
    "recommendedStore": "Popular Stores",
    "推荐码不正确": "The recommendation code is wrong",
    "推荐人无权限推荐": "No authority to recommend",
    "推荐商品": "Popular Items",
    "logout": "Log out",
    "returnsAndEx": "Returns and Exchange",
    "returnAmount": "Return Amount",
    "returnRemark": "Return Instructions",
    "returnPolicy": "Return Policy",
    "Refund": "Refund",
    "refund": "Refund/after-sales",
    "退款成功": "Refund succeeded",
    "refundSuccessfully": "Refund succeeded",
    "refundSuccess": "Refund succeeded",
    "returnReason": "Refund Reason",
    "returnApply": "Refund Request",
    "退款失败": "Refund failed",
    "refundFail": "Refund failed",
    "refundInstructions": "Refund Instructions",
    "refunding": "Refund in progress",
    "mastercard": "MasterCard",
    "EsShop": "Online store",
    "ForgotPassword": "Forgot the password?",
    "委托数量(张)必填": "Entrusted quantity (pcs.) is required",
    "委托数量(张)不能小于等于0": "The entrusted quantity (pcs.) cannot be less than or equal to 0",
    "foryourmoney": "Online loans are a convenient and fast option to solve your financial problems. You won't feel embarrassed like when you borrow money from friends. Our professional team will help you to go through the process and clear your doubts anytime. We aim to give our customers every loan quickly, transparently and safely.",
    "storeSeachTips1": "Find for you",
    "未绑定谷歌验证器": "Google Authenticator has not been linked",
    "未绑定手机号": "The mobile number has not been added",
    "未绑定邮箱": "The email has not been added",
    "未发现授权记录": "Authorization record has not been found",
    "notQua": "Did not meet the requirements",
    "ShippingAddressNotSet": "The shipping address has not been set",
    "未实名认证，是否认证？": "Not authenticated by real name. Authenticate?",
    "cancelOrder1": "The product has not been received",
    "未授权访问": "Unauthorized access",
    "noRefund": "Not refunded",
    "未找到符合条件的匹配订单": "No matching order found",
    "未找到匹配的收益记录": "No matching revenue record found",
    "mine": "My",
    "myloan": "My Loan",
    "myOrder": "My Orders",
    "myComment": "My Reviews",
    "myPoint": "My Points",
    "accountInfo": "Account Info",
    "myBalance": "My Deposit",
    "myCoupon": "My Coupons",
    "unused": "Unused",
    "used": "Used",
    "expired": "Expired",
    "expires": "Expires",
    "minSpend": "Min. spend",
    "availableBalance": "Available Balance",
    "personalDeposit": "Deposit",
    "useDepositBalance": "Use deposit balance",
    "depositDeduct": "Deposit deduction",
    "useMaxDeposit": "Deduct maximum",
    "balanceHistory": "Balance History",
    "recordCount": "{count} records",
    "depositType": "Category",
    "balanceAfter": "Balance After",
    "depositTypeRecharge": "Deposit recharge",
    "depositTypeAdjustment": "Balance adjustment",
    "depositTypeOrderPayment": "Order payment",
    "depositTypeOrderRefunds": "Order refund",
    "depositTypeDistributionCommission": "Distribution commission",
    "depositTypeDistributionWithdrawal": "Distribution withdrawal",
    "depositTypeOther": "Other",
    "income": "Income",
    "expense": "Expense",
    "description": "Description",
    "myFootprint": "My Footprint",
    "myCart": "My Shopping cart",
    "我的购物车": "My Shopping cart",
    "myPurse": "My Wallet",
    "myAccount": "My Account",
    "aboutText1": "\"We provide loan services based on the business philosophy of \"\"Customer comes first\"\", which aims to solve customers' capital financial problems. Since the company was established, we have helped many customers to solve their capital turnover problems.\"",
    "readAndAgree": "I have read and accepted",
    "safeInfo": "Require no mortgage, no deposit, and no callback. It is a private matter.",
    "无权限": "No permissions",
    "无效的UID": "Invalid UID",
    "item": "Item",
    "系统参数错误": "System parameter error",
    "系统存在相同[系统登录名]！": "Another user already exists in the system with the same login name",
    "系统错误，请稍后重试": "System error, please try again later",
    "系统发货成功": "Succeeded",
    "系统默认好评": "Good reviews by default",
    "defaultRate": "Good reviews by default",
    "checkout": "Place an order",
    "下单不能小于最小金额限制": "Order placement amount cannot be less than the minimum limit",
    "下单成功，等待付款": "The order has been placed successfully, and we are waiting for the payment",
    "下单成功，付款成功": "Payment succeeded",
    "buyTips": "After placing the order, it will be shipped within 24 hours. The shipping time depends on logistics and may be prolonged. Please pay attention to the logistics information or contact Customer Service.",
    "nextPage": "Next page",
    "stateMent": "Modern Slavery Statement",
    "storeSeachTips2": "Related stores found",
    "address": "Detailed Address",
    "items": "Item",
    "browse": "Total Sales",
    "sold": "Sold",
    "sales": "Total Sales",
    "校验IP不合法": "Verification IP is invalid",
    "new": "New",
    "newPassword": "New password",
    "新密码不能为空": "The field cannot be empty",
    "新密码不一致": "The password doesn't match",
    "新密码确认不能为空": "The field cannot be empty",
    "news": "News",
    "addNewAddress": "Add new address",
    "creditTit": "Credit Loan Service",
    "Information": "Information",
    "行情获取异常，稍后再试": "The quotation is abnormal, please try again later",
    "modifyAddress": "Change address",
    "handlingfee": "Service charge is required",
    "Opt": "Select",
    "selectDeliveryAddress": "Choose a shipping address",
    "验证类型不能为空": "The field cannot be empty",
    "验证码不能为空": "The field cannot be empty",
    "验证码不正确": "Incorrect verification code",
    "验证码错误": "Verification code error",
    "vcodeFail": "Verification failed, please try again",
    "vcodePass": "Verified!",
    "invitationCode": "Invitation code",
    "页码不能小于等于0": "The page number cannot be less than or equal to 0",
    "页码不是整数": "The page number is not an integer",
    "dashboard": "Dashboard",
    "loaned": "Loaned",
    "loanDays": "Duration",
    "已发货，正在运输中": "Shipped, in transportation",
    "followed": "Followed",
    "repaid": "Repayment",
    "已领取": "Received",
    "rated": "Reviewed",
    "cancelled": "Cancelled",
    "confirmed": "Confirmed",
    "harvested": "Received",
    "mySold": "Sold",
    "overdue": "Overdue",
    "privacyPolicy": "Privacy Policy",
    "用户不存在": "The user does not exist",
    "用户名必须由数字和英文字母组成": "The user name must consist of numbers and letters",
    "用户名不存在": "The user does not exist",
    "用户名不符合设定": "The user name does not match",
    "用户名不能为空": "The field cannot be empty",
    "用户名参数为空": "The field cannot be empty",
    "用户名重复": "Copy user name",
    "userEvaluation": "User reviews",
    "用户剩余数量不足": "Insufficient number of users",
    "用户未发表评论": "Users have not left any comments",
    "用户已跟随交易员": "The user is following the store",
    "user_Center": "User Center",
    "userReg": "User Registration",
    "postCode": "Postal Code",
    "orderEmail": "Email",
    "邮箱已绑定": "The email has already been bound",
    "邮箱已绑定其他用户": "The email has already been bound to another user",
    "orderPostCode": "Postal Code",
    "hasImage": "With pictures",
    "Balance": "Balance",
    "balance": "Balance (USDT)",
    "余额不足": "Insufficient balance",
    "balanceNot": "The balance is not enough, please deposit",
    "shop_order_insufficientBalance": "Balance is insufficient",
    "cancelOrder8": "Negotiate a refund with the seller",
    "expectedArrival": "Expected arrival",
    "esRepayment": "Estimated repayment",
    "estirepay": "Estimated repayment",
    "originPrice": "Original price",
    "deliveryFee": "Freight",
    "goodsFreight": "Freight",
    "shippingDiscounts": "Freight discount",
    "homeIconTips3": "Freight discount",
    "desc6": "Enter your transaction password again",
    "rebuy": "One more order",
    "onlineService": "Online Services",
    "customeService": "Online Customer Service",
    "helpLine": "Online Customer Service",
    "onlineApplin": "Apply Online",
    "暂无店铺": "No store found",
    "noComments": "No comments yet",
    "noData": "No data found",
    "帐户异常需要进行C3认证，请联系在线客服。": "Account exception requires C3 authentication. Please contact online Customer Service.",
    "account": "Account",
    "accountBalance": "Account Balance",
    "accountB": "Account Balance",
    "accountReview": "Account Overview",
    "Recruitment": "Careers",
    "找不到用户": "The user has not been found",
    "searchTips": "Search for brands/products/suppliers",
    "hotSearch": "Hot Search:",
    "discount": "Discounts",
    "homeDownloadtips3": "Non-stop discounts",
    "discounted": "Discounts",
    "flashSale": "Flash Sale",
    "groupBuy": "Group Buy",
    "groupBuying": "Group Buying",
    "couponCenter": "Coupon Center",
    "pointMall": "Point Mall",
    "liveList": "Live",
    "endsIn": "Ends in",
    "soldOut": "Sold",
    "people": "People",
    "joined": "Joined",
    "startGroup": "Start Group Buy",
    "getCoupon": "Get Coupon",
    "getCouponSuccess": "Coupon claimed",
    "liveRooms": "Live Rooms",
    "liveStreaming": "Live",
    "notStarted": "Not Started",
    "finished": "Ended",
    "myPoints": "My Points",
    "searchGoods": "Search Products",
    "points": "Points",
    "point": "Points",
    "stock": "Stock",
    "spec": "Spec",
    "exchangeNow": "Exchange Now",
    "currentPoint": "My Points",
    "pointNotEnough": "Insufficient points",
    "actualName": "Full Name",
    "passPortImg": "ID /Passport Number",
    "uploadId": "Upload ID/Passport Photo",
    "Payment": "Payment",
    "pay": "Payment",
    "paymentSuccessful": "Payment succeeded",
    "paymentMethod": "Payment Methods",
    "paymethods": "Payment Methods",
    "payCertificate": "Payment Certificate",
    "直线关系，不能修改推荐": "Straight line relation, recommendation cannot be modified",
    "tipsRemindsCount": "Can be reminded only once",
    "committed": "We are dedicated to providing loan services to entrepreneurs",
    "mediumOpinion": "Average reviews",
    "sort": "Type",
    "重复提交": "Re-submit",
    "Reapply": "Re-apply",
    "register": "Register",
    "signUp": "Register",
    "registerSuccess": "Registration succeeded",
    "转账币种不能为空": "The field cannot be empty",
    "转账数量不能小于等于0": "The transfer amount cannot be less than or equal to 0",
    "orderStatus": "Status",
    "orderState": "Status",
    "状态不能小于0": "Status cannot be less than 0",
    "状态不是整数": "Status is not an integer",
    "资金密码必须6-12位": "The fund password must be 6-12 characters",
    "资金密码不符合设定": "The fund password does not match",
    "资金密码不能为空": "The field cannot be empty",
    "资金密码错误": "Fund password error",
    "资金密码长度不符合设定": "The length of the password does not match the settings",
    "complex": "Sum up",
    "totalOf": "Total",
    "totalPrice": "Total Price",
    "homeBannertips3": "Max.",
    "creditReview": "Pass the audit in one hour at the earliest. If the review is passed, the loan will be released right away.",
    "yesterday": "Yesterday",
    "binance": "Binance",
    "huobi": "Huobi",
    "validatorIpRule": "Incorrect IP address",
    "metaMask": "MetaMask",
    "footTip": "{name} Limited 2024. All Rights Reserved.",
    "footTips": "{name} Limited is authorized and regulated by the Financial Conduct Authority as a credit broker (713206) and deals exclusively with the lender Home Retail Group CardServices Limited as MetaShop Financial Services. {name} Financial Services is authorized and regulated by the Financial Conduct Authority to provide credit (716148). Home Retail GroupCard Services Limited is registered in the United Kingdom (04007072) at Avebury, 489-499 Avebury Boulevard, Milton Keynes, United Kingdom. MK9 2NW.",
    "footdec": "{name} global site users come from {num} countries around the world and use {coin} for settlements. {coin} is a borderless transaction that enables immediate, low-cost transactions around the world without waiting and charging international fees.",
    "okx": "okx",
    "备注": "Remarks",
    "UID不能为空": "UID cannot be empty",
    "滑动验证": "Drag the slider to complete the puzzle",
    "头像选择": "Select a photo",
    "修改头像": "Change ",
    "银行卡": "Bank Card",
    "平台人工发起退款": "Platform-initiated refund",
    "最多上传9张图片": "Upload up to 9 pictures",
    "账号注销": "Account cancellation",
    "确定注销": "Confirm cancellation",
    "您的账号": "Your account",
    "为什么要离开": "Why do you want to leave",
    "您还有余额,不能注销账号": "You still have a balance, you cannot cancel your account!",
    "请输入注销理由": "Please enter the reason for cancellation",
    "您确认要注销吗?": "Are you sure you want to cancel?",
    "我再考虑下": "I'll think about it",
    "同意注销": "Agree to cancel",
    "注销成功": "Cancellation succeeded",
    "请选择": "Please select",
    "提款地址绑定": "Withdrawal address binding",
    "绑定成功": "Binding succeeded",
    "仅能绑定一个收款地址!": "Only one address can be bound!",
    "加值": "Add value",
    "提领": "Withdrawal",
    "联系商家": "Contact seller",
    "最多包含10位小数": "Up to 10 decimal places",
    "企业电话": "Business Phone",
    "加密货币": "Cryptocurrency",
    "职业机会": "career opportunities",
    '参数缺失': "Missing parameters",
    '充值数量必填': "The field cannot be empty",
    "银行卡": "Bank Card",
    "充值币种": "Deposit currency",
    "充值金额": "Deposit amount",
    "充值金额不得小于": "The Deposit amount cannot be less than",
    "充值金额不得大于": "The Deposit amount cannot be greater than",
    "请先选择币种": "Please select a currency first",
    "开户行": "Bank",
    "请输入开户行名称": "Please enter the bank name",
    "银行卡号": "Bank Card Number",
    "请输入银行卡号": "Please enter the bank card number",
    "点击去支付": "Click to pay",
    "企业证明": "Enterprise certification",
    "footTipTikTok":'BizSpring ©️2024 Copyright',
    "TikTokFoot":"BizSpring is a global short-video social platform BizSpring and Asia's largest wholesale trading company Alibaba, established in cooperation. It is a global e-commerce platform and has three self-operated smart warehouses in the world, located in Toronto, Canada, Los Angeles, and Chiba, Japan. The products on sale in the app include popular products from Japan, South Korea, China and other Asian countries. At present, the total number has exceeded 50,000 and continues to grow rapidly.",
    "cancelInfo":"Warn! Please be careful to cancel the account. If you no longer use the account, you can click [Agree to Cancellation]. You may not be able to register within a few days after cancellation.",
    "seckillPrice": "Seckill Price",
    "seckillTag": "Seckill",
    "seckillCountdown": "Ends in",
    "seckillNotStarted": "Coming Soon",
    "seckillRushing": "Rushing Now",
    "seckillWillStart": "Coming Soon",
    "seckillBuy": "Buy Now (Seckill)",
    "groupPrice": "Group Price",
    "groupRequiredNum": "people to complete group",
    "noGroupBuy": "Buy Alone",
    "groupRule1": "1. Select item",
    "groupRule2": "2. Start group",
    "groupRule3": "3. Group complete → ship",
    "marketingMoneyOff": "Money Off",
    "marketingFreeShipping": "Free Ship",
    "marketingGift": "Gift",
    "marketingCoupon": "Coupon",
    "marketingGroup": "Group Buy",
    "marketingSeckill": "Seckill",
    "alreadyGotCoupon": "Claimed",
    "couponReceived": "Received",
    "marketingExpired": "Promotion expired",
    "marketingNotActive": "Promotion not active",
    "🔍 预览模式 · 当前显示的是装修器中的草稿内容（未发布）": "🔍 Preview Mode · Showing draft decoration content (unpublished)",
    "领取": "Claim",
    "暂无优惠券": "No coupons",
    "暂无品牌": "No brands",
    "addImageHint": "(Please add images)",
    "deleteNode": "Delete",
    "topPos": "Top {n}",
    "col": "Col {n}",
    "pos": "Pos {n}",
    "decoType_container": "Container",
    "decoType_title": "Title",
    "decoType_richText": "Rich Text",
    "decoType_notice": "Notice",
    "decoType_blank": "Spacer",
    "decoType_banner": "Carousel",
    "decoType_imageSingle": "Single Image",
    "decoType_imageMulti": "Multi Image",
    "decoType_video": "Video",
    "decoType_goodsRecommend": "Goods Recommend",
    "decoType_goodsSelection": "Goods Selection",
    "decoType_seckill": "Flash Sale",
    "decoType_groupBuy": "Group Buy",
    "decoType_coupon": "Coupon",
    "decoType_searchNav": "Search Nav",
    "decoType_search": "Search Box",
    "decoType_searchBox": "Search Box",
    "decoType_categoryNav": "Category Nav",
    "decoType_goodsCategory": "Goods Category",
    "decoType_navIconRow": "Nav Icons",
    "decoType_imageScroll": "Image Scroll",
    "decoType_pageBanner": "Page Banner",
    "decoType_tabs": "Tabs",
    "decoType_brand": "Brand",
    "decoType_storeRecommend": "Store Recommend",
    "decoType_hotSelection": "Hot Selection",
    "decoType_footerLinkGroup": "Footer Links",
    "decoType_partnerLogoRow": "Partners",
    "decoType_icpInfo": "ICP Info",
    "decoType_topNavMenu": "Top Nav",
    "decoType_logoBlock": "Logo",
    "decoType_langSwitcher": "Language",
    "decoType_currencySwitcher": "Currency",
    "decoType_loginBlock": "Login",
    "decoType_cartIcon": "Cart",
    "decoType_messageIcon": "Messages",
    "搜索": "Search",
    "搜索提示文字": "Search hint",
    "请输入关键字": "Please enter keyword",
    "请输入关键词": "Please enter keyword",
    "contactInfo": "Contact Information",
    "consignee": "Full Name",
    "phone": "Phone",
    "enterName": "Enter full name",
    "enterPhone": "Enter phone number",
    "country": "Country",
    "province": "State/Province",
    "detailAddress": "Detail Address",
    "enterAddress": "Enter street address",
    "paymentInfo": "Payment Information",
    "cardNumber": "Card Number",
    "cardHolder": "Cardholder Name",
    "enterCardHolder": "Enter cardholder name",
    "expiryDate": "Expiry Date",
    "cardNumberRequired": "Card number is required",
    "cardHolderRequired": "Cardholder name is required",
    "expiryDateRequired": "Expiry date is required",
    "emailRegistered": "This email is already registered. You can login after checkout.",
    "nameRequired": "Name is required",
    "phoneRequired": "Phone is required",
    "countryRequired": "Country is required",
    "addressRequired": "Address is required",
    "cardExpired": "Card has expired",
    "registerFailed": "Registration failed",
    "accountExists": "Account already exists, please login to continue",
    "operationFailed": "Operation failed",
    "continueToCheckout": "Continue to Checkout",
    "emailRequired": "Email is required",
    "emailInvalid": "Invalid email format",
    "中文繁體": "繁體中文",
    "中文简体": "简体中文",
    "日本語": "日本語",
    "shoppingCart": "Shopping Cart",
    "selectAll": "Select All",
    "goodsName": "Product Name",
    "subtotal": "Subtotal",
    "action": "Action",
    "selected": "Selected",
    "total": "Total",
    "emptyCart": "Your shopping cart is empty",
    "allStores": "All Stores",
    "searchStore": "Search stores",
    "viewStore": "Visit Store",
    "streamEnded": "Stream Ended",
    "liveGoods": "Live Products",
    "announcements": "Announcements",
    "pointHistory": "Points History",
    "type": "Type",
    "remark": "Remark",
    "accountBind": "Account Binding",
    "mobileBind": "Mobile Binding",
    "notBound": "Not Bound",
    "change": "Change",
    "bind": "Bind",
    "emailBind": "Email Binding",
    "enterMobile": "Enter mobile number",
    "enterEmail": "Please enter email",
    "verifyCode": "Verification Code",
    "enterCode": "Enter verification code",
    "sendCode": "Send Code",
    "codeSent": "Code sent successfully",
    "bindSuccess": "Binding succeeded",
    "save": "Save",
    "saveSuccess": "Saved successfully",
    "balancePay": "Balance Pay",
    "wechatPay": "WeChat Pay",
    "alipay": "Alipay",
    "totalAmount": "Total Amount",
    "confirmPay": "Confirm Payment",
    "paySuccess": "Payment succeeded",
    "renew": "Renew",
    "vipPrivileges": "VIP Privileges",
    "growthValue": "Growth Value",
    "expiry": "Expiry",
    "pointLottery": "Points Lottery",
    "costPoints": "Cost Points",
    "startLottery": "Start Lottery",
    "congratulations": "Congratulations",
    "betterLuckNextTime": "Better luck next time",
    "noLottery": "No lottery available",
    "insufficientPoints": "Insufficient points",
    "pendingComment": "Pending Review",
    "commented": "Reviewed",
    "close": "Close",
    "loginFail": "Login failed",
    "paymentFailed": "Payment failed",
    "subscribe": "Subscribe",
    "confirmDelete": "Are you sure you want to delete?",
    "tips": "Tips",
    "deleteSuccess": "Deleted successfully"
};
